import { Controller } from '@hotwired/stimulus';
import { Identicon } from 'src/identicon';

export default class IdenticonController extends Controller {
  declare dataValue: string;

  public static values = {
    data: String,
    size: Number,
  };

  public connect(): void {
    const data = new Identicon(this.dataValue, {}).toString();

    const image = new Image();
    image.setAttribute('src', `data:image/svg+xml;base64,${data}`);
    this.element.append(image);
  }

  public disconnect(): void {
    this.element.innerHTML = '';
  }
}
